import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

const supportedLanguages = ['en', 'en-GB', 'es', 'pt'];
const storedLanguage = localStorage.getItem('language');
const defaultLanguage = supportedLanguages.includes(storedLanguage) ? storedLanguage : 'en';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    lng: defaultLanguage,
    debug: false,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
